<template>
    <label class="radioboxes__item" :class="{ 'is-disabled': disabled }">
        <input
            class="radioboxes__input"
            :name="radioButtonState.inputName"
            :value="value"
            type="radio"
            :checked="value === activeItem"
            :disabled="disabled"
            @change="onChange"
        />
        <div class="radioboxes__box">
            <span class="radioboxes__checkmark"></span>
            <div v-if="label" class="radioboxes__label">{{ label }}</div>
            <div class="radioboxes__content">
                <slot></slot>
            </div>
        </div>
    </label>
</template>

<script>
export default {
    name: 'RadioBox',
    inject: ['radioButtonState', 'setValue'],
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number],
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        activeItem() {
            return this.radioButtonState.value;
        }
    },
    methods: {
        onChange(event) {
            this.setValue(event.target.value);
        }
    }
};
</script>
